/*
* Overview of available enums: https://gitlab.com/digital-pharma-dp3/pharma-cms/-/tree/master/application/src/Model/Enum
*/
export enum EnumClassNameOrderEnum {
    ENUMERATION_CONTENT_TYPE = "App\\Model\\Enum\\EnumerationContentTypeEnum",
    DELIVERY_METHOD = "DigitalPharma\\Base\\Model\\Enum\\DeliveryMethodEnum",
    COUNTRY = "DigitalPharma\\Base\\Model\\Enum\\CountryEnum",
    NOTIFICATION_TYPE = "App\\Model\\Enum\\NotificationTypeEnum",
}
